export enum Target {
  SELF = '_self',
  BLANK = '_blank',
}

export const targetKeys = Object.keys(Target);
export const targetValues = Object.values(Target);

export enum ButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export const buttonTypeKeys = Object.keys(ButtonType);
export const buttonTypeValues = Object.values(ButtonType);

export enum ButtonAlignment {
  LEFT = 'left',
  CENTER = 'center',
}

export enum ButtonAppearance {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  SUCCESS = 'success',
  ERROR = 'error',
  BOTTOM_FIXED = 'bottom-fixed',
}

export const buttonAppearanceKeys = Object.keys(ButtonAppearance);
export const buttonAppearanceValues = Object.values(ButtonAppearance);
